import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {shallowEqual, useSelector} from 'react-redux';
import {useTaskAndNotesGridContext} from '../../../../contexts/TaskAndNotesGridContext';
import {StyledFieldDatepicker} from '../../../FieldDatepicker';
import {StyledFieldSelect} from '../../../FieldSelect';
import {StyledFieldTextareaAutosize} from '../../../FieldTextareaAutosize';
import {getFieldLabel} from '../../utils/getFieldLabel';
import {filterOptions} from '../../../../utils/options';
import ButtonAction from '../../../ButtonAction';
import ModalContainer from '../../../ModalContainer';
import ModalHeader from '../../../ModalHeader';
import ModalContent from '../../../ModalContent';
import ModalButtonsContainer from '../../../ModalButtonsContainer';
import {toAbsoluteUrl} from '../../../../../../../_metronic/_helpers';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../../styles/styles';

const PopupCreateEditGeneralNote = ({
                                      generalNoteID,
                                      onOpen,
                                      onEdit,
                                      disabled
                                    }) => {
  const intl = useIntl();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = async () => {
    setShow(true);
    if (onOpen) await onOpen(generalNoteID);
  };
  const handleEdit = async () => {
    if (onEdit) await onEdit(generalNoteID);
    handleCloseModal();
  };
  const isNewNote = generalNoteID === -1;
  const prefix = 'tab-order-inspections-tasks-popup';

  const {formik, fieldNames, generalNoteStatusTypes} = useTaskAndNotesGridContext();
  const {isValid, dirty} = formik;
  const {users} = useSelector((state) => ({users: state.usersReducer.users}), shallowEqual);

  const getLabel = () => {
    if (isNewNote) {
      return (
        <>
          <img
            src={toAbsoluteUrl('/media/common/Plus_white.svg')}
            alt="create" className={'mr-2'}
          />
          {intl.formatMessage({id: `${prefix}-button-label-generalNote`, defaultMessage: 'General note'})}
        </>
      );
    } else {
      return <img src={toAbsoluteUrl('/media/common/Edit_primary.svg')} alt="edit" className="w-20px h-20px"/>;
    }
  };
  const header = [
    intl.formatMessage({id: `${prefix}-button-label-generalNote`, defaultMessage: 'General note'}),
    isNewNote ? '' : generalNoteID,
  ].filter(Boolean).join(' - ');

  return (
    <>
      {isNewNote
        ? (
          <ButtonAction
            variant={'success'}
            label={getLabel()}
            onClick={handleShowModal}
            disabled={disabled}
            customClassnames={'w-225px mx-2'}
          />
        )
        : (
          <ButtonAction
            variant={'icon'}
            iconButtonType={'primary'}
            label={getLabel()}
            onClick={handleShowModal}
            disabled={disabled}
          />
        )
      }
      <ModalContainer show={show} onHide={handleCloseModal} size={'md'}>
        <ModalHeader header={header}/>
        <ModalContent customClassnames={'bg-transparent'}>
          <StyledFieldSelect
            fieldId={fieldNames.generalNoteStatusTypeID}
            value={filterOptions(formik.values[fieldNames.generalNoteStatusTypeID])(generalNoteStatusTypes)}
            onChange={(option) => formik.setFieldValue(fieldNames.generalNoteStatusTypeID, option.value)}
            options={generalNoteStatusTypes}
            label={getFieldLabel(intl.formatMessage({id: `${prefix}-status`, defaultMessage: 'Status'}))}
            customContainerStyles={'py-3'}
          />
          <StyledFieldDatepicker
            value={formik.values[fieldNames.generalNoteDueDate]}
            onChange={(date) => formik.setFieldValue(fieldNames.generalNoteDueDate, new Date(date))}
            label={getFieldLabel(intl.formatMessage({id: `${prefix}-dueDate`, defaultMessage: 'Due date'}), false)}
            customContainerStyles={'py-3'}
          />
          <StyledFieldSelect
            fieldId={fieldNames.generalNoteResponsibleUserID}
            value={filterOptions(formik.values[fieldNames.generalNoteResponsibleUserID])(users)}
            onChange={(option) => formik.setFieldValue(fieldNames.generalNoteResponsibleUserID, option.value)}
            options={users}
            label={getFieldLabel(intl.formatMessage({
              id: `${prefix}-responsibleUser`,
              defaultMessage: 'Responsible user'
            }), false)}
            customContainerStyles={'py-3'}
          />
          <StyledFieldTextareaAutosize
            fieldId={fieldNames.generalNoteFreeText}
            onChange={(e) => formik.setFieldValue(fieldNames.generalNoteFreeText, e.target.value)}
            value={formik.values[fieldNames.generalNoteFreeText]}
            label={getFieldLabel(intl.formatMessage({
              id: `${prefix}-freeText`,
              defaultMessage: 'Description'
            }), false)}
            customContainerStyles={'py-3'}
            customLabelStyles={'fs-6'}
            maxRows={6}
          />
        </ModalContent>
        <ModalButtonsContainer customClassnames={largeButtonsPadding}>
          <ButtonAction
            variant={'cancel'}
            label={intl.formatMessage({id: `button-cancellation`, defaultMessage: 'Close'})}
            onClick={handleCloseModal}
            customClassnames={buttonCancel}
          />
          <ButtonAction
            useIcon={'/media/common/Check-in-circle_white.svg'}
            label={intl.formatMessage({id: `submit`, defaultMessage: 'Submit'})}
            onClick={handleEdit}
            disabled={!(isValid && dirty)}
            customClassnames={buttonSubmit}
          />
        </ModalButtonsContainer>
      </ModalContainer>
    </>
  );
};

export default PopupCreateEditGeneralNote;